import { createSlice } from "@reduxjs/toolkit";
import { isLogin } from "../../services/auth.service";

const initialState = {
  user: {},
  isLoggedIn: isLogin(),
  isLoding: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    onLogin(state, action) {
      state.isLoggedIn = isLogin();
    },
    onLogout(state, action) {
      state.isLoggedIn = false;
    },
    setUser(state, action) {
      state.user = action.payload;
    },
    updateUsers(state, action) {
      state.isLoding = false;
      state.user = action.payload;
    },
    setUserLoading(state, action) {
      state.isLoding = true;
    },
  },
});

export const { onLogout, onLogin, setUser, updateUsers, setUserLoading } =
  userSlice.actions;
export default userSlice.reducer;
